
//import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
/*
import {
	//NoConflictStyleCompatibilityMode, 
	MatButtonModule, 
	MatCheckboxModule, 
	MatRadioModule, 
	MatSliderModule, 
	MatSlideToggleModule, 
	MatInputModule, 
	MatIconModule,
	MatSelectModule, 
	MatFormFieldModule, 
	MatChipsModule, 
	MatProgressSpinnerModule,
	MatProgressBarModule,
	MatDialogModule, 
	MatDialog, 
	MatDialogRef, 
	MatTooltipModule,
	MatNativeDateModule,
	MatDatepickerModule,
	MatTabsModule, 
	MatAutocompleteModule,
	//MatTableModule,
	MatBadgeModule,
	MatListModule,
	MatSnackBarModule,
	MatButtonToggleModule,
	MatExpansionModule,
} 
	from '@angular/material';
*/
import { ModuleWithProviders, NgModule} from "@angular/core";
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';


import { HttpClientModule } from '@angular/common/http';

import { Ng4FilesModule } from './picture/ng4-files';
import { Ng2ImgMaxModule } from 'ng2-img-max';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { TinymceModule } from 'angular4-tinymce-biznet';

import { ConfirmDialog } from './confirm-dialog/confirm-dialog.component';
import { AlertDialog } from './alert-dialog/alert-dialog.component';
import { ApiService, DialogsService, FilterService } from './Services/';

import { AutocompleteDialogComponent } from './autocomplete-dialog/autocomplete-dialog.component';
import { PictureComponent } from './picture/picture.component';
import { SeemoreComponent } from './seemore/seemore.component';
import { MultilinePipe } from './pipes/multiline.pipe';
import { ReplacePipe } from './pipes/replace.pipe';
import { SelectorComponent } from './selector/selector.component';
import { ThbtnsComponent } from './thbtns/thbtns.component';
import { FocusDirective } from './directives/focus/focus.directive';
import { AutoEditableComponent } from './auto-editable/auto-editable.component';
import { TranslocoRootModule } from '../transloco/transloco-root.module';

//let tinymceBaseUrl = window['__env'].baseUrl+'/miiar/assets/tinymce/';


@NgModule({
	imports: [ 
		//NoConflictStyleCompatibilityMode,
		MatButtonModule, 
		MatCheckboxModule, 
		MatRadioModule, 
		MatSliderModule, 
		MatSlideToggleModule, 
		MatInputModule, 
		MatIconModule,
		MatDialogModule, 
		MatAutocompleteModule, 
		MatTabsModule, 
		MatSelectModule, 
		MatFormFieldModule, 
		MatChipsModule, 
		MatProgressSpinnerModule,
		MatProgressBarModule,
		MatTooltipModule,
		MatNativeDateModule,
		MatDatepickerModule,
		//MatTableModule,
		MatBadgeModule,
		MatListModule,
		MatSnackBarModule,
		MatButtonToggleModule,
		MatExpansionModule,
		//NgbModule,

		FormsModule, 
		ReactiveFormsModule,
		BrowserModule, 
		Ng4FilesModule,
		Ng2ImgMaxModule,
		HttpClientModule,
	    /*TinymceModule.withConfig({
	        language: 'fr_FR',
	        height: 600,
	        theme: 'modern',
	        skin_url: tinymceBaseUrl+'skins/lightgray',
	        external_plugins: {
	          image: tinymceBaseUrl+'plugins/image/plugin.js',
	          imagetools: tinymceBaseUrl+'plugins/imagetools/plugin.js',
	          textcolor: tinymceBaseUrl+'plugins/textcolor/plugin.js',
	          colorpicker: tinymceBaseUrl+'plugins/colorpicker/plugin.js',
	          table: tinymceBaseUrl+'plugins/table/plugin.js',
	          pagebreak: tinymceBaseUrl+'/plugins/pagebreak/plugin.js',
	          lists: tinymceBaseUrl+'/plugins/lists/plugin.min.js',
	          code: tinymceBaseUrl+'/plugins/code/plugin.js',
	          fullscreen: tinymceBaseUrl+'/plugins/fullscreen/plugin.js',
	          //paste: tinymceBaseUrl+'/plugins/paste/plugin.min.js',
	          //poodll: tinymceBaseUrl+'/plugins/poodll/poodll.js',
	        },
	        toolbar: 'undo redo | styleselect | bold italic | numlist bullist | alignleft aligncenter alignright | link  image imagetools | forecolor backcolor table',
	        images_upload_handler: function (blobInfo, success, failure) {
	          success('data:image/png;base64,'+blobInfo.base64());
	        }
	      })*/
		TranslocoRootModule
	],
	exports: [
		//NoConflictStyleCompatibilityMode,
		MatButtonModule, 
		MatCheckboxModule, 
		MatRadioModule, 
		MatSliderModule, 
		MatSlideToggleModule, 
		MatInputModule, 
		MatIconModule,
		MatDialogModule, 
		MatAutocompleteModule, 
		MatTabsModule, 
		MatSelectModule, 
		MatFormFieldModule, 
		MatChipsModule, 
		MatProgressSpinnerModule,
		MatProgressBarModule,
		MatTooltipModule,
		MatNativeDateModule,
		MatDatepickerModule,
		//MatTableModule,
		MatBadgeModule,
		MatListModule,
		MatSnackBarModule,
		MatButtonToggleModule,
		MatExpansionModule,
		//NgbModule,

		//TinymceModule,


	  ConfirmDialog, AlertDialog, PictureComponent, SeemoreComponent, 
	  SelectorComponent, ThbtnsComponent,
	  
	  MultilinePipe, ReplacePipe, FocusDirective, AutoEditableComponent, 

	  //ApiService, DialogsService, FilterService
	],

	declarations: [
	    ConfirmDialog, AlertDialog,
	    AutocompleteDialogComponent,
	    PictureComponent,
	    SeemoreComponent,
	    MultilinePipe,
	    ReplacePipe,
	    SelectorComponent,
	    ThbtnsComponent,
	    FocusDirective,
	    AutoEditableComponent,
	    

	],
	entryComponents: [
	    ConfirmDialog, AlertDialog,
	    AutocompleteDialogComponent
	],
  	providers: [
  		ApiService, DialogsService, FilterService,
		  {provide: MAT_DATE_LOCALE, useValue: 'fr-FR'}
  	]
})
export class CustomMaterialModule { }